import React, { Component } from "react";
import "./App.css";
import MainRoutes from "./containers/pages/MainRoutes";
import { ConnectedRouter } from "connected-react-router";
import { HashRouter } from "react-router-dom";
import ReactGA from "react-ga";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      localDirectClient: false,
    };
  }
  componentWillMount = () => {
    // const script = document.createElement("script");
    // //script.src = "https://stg-id.singpass.gov.sg/static/ndi_embedded_auth.js";
    // script.src = process.env.REACT_APP_SING_PASS_SCRIPT_SRC;
    // script.async = true;
    // script.onload = () => {
    //   // script has loaded, you can now use it safely
    //   //console.log("a")
    // };
    // document.body.appendChild(script);
  };

  componentDidMount = () => {
    // sessionStorage.clear();
    if (localStorage.getItem("IsLogOut") === "true") {
      localStorage.removeItem("IsLogOut");
      localStorage.removeItem("MyToken");
    }

    localStorage.removeItem("IsEditableNameAndDOB");
    localStorage.removeItem("IsMasterAccount");
  };

  initGA = () => {
    ReactGA.initialize(process.env.REACT_APP_GA_ID);

    ReactGA.pageview(window.location.pathname + window.location.search);
  };

  render() {
    const { history } = this.props;
    return (
      <HashRouter history={history}>
        <div className="App">
          <MainRoutes directClient={this.state.localDirectClient} />
        </div>
      </HashRouter>
    );
  }
}

export default App;
